import React from "react";
import {Outlet} from "react-router-dom";
import Header from "../components/header/Header";
import Sidebar from "../components/sidebar/Sidebar";

const RootLayout = () => {
    return (
        <>
            <div className="layout layout-full-sidebar d-grid bg-body-tertiary overflow-hidden">
                <header className="layout-header py-2 px-3 border-bottom bg-white">
                    <Header/>
                </header>
                <aside className="layout-aside">
                    <Sidebar/>
                </aside>
                <main className="layout-content p-2 mx-3 mx-md-0">
                    <div className="bg-white p-2 rounded-4">
                        <Outlet/>
                    </div>
                </main>
            </div>
        </>
    )
};

export default RootLayout;
